import React, { useState } from 'react';
import { useTranslation } from '~/shared/utils/translation';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import VouchersList from '../../components/VouchersList/VouchersList';
import VouchersCardDrawer from '../../components/VouchersCardDrawer/VouchersCardDrawer';
import { useActiveVouchers } from '~/shared/hooks/loyalty/queries/useActiveVouchers';
import { mapVoucherToVoucherWithDetails, VoucherWithDetails } from '../../lib/loyaltyDataMappers';

import styles from './ProfileTabs.module.scss';

const Vouchers: React.FC = () => {
    const { translate } = useTranslation();
    const { data: voucherData, isLoading, error } = useActiveVouchers();

    // State for drawer
    const [selectedVoucher, setSelectedVoucher] = useState<VoucherWithDetails | null>(null);
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Transform API data to UI format
    const vouchers: VoucherWithDetails[] =
        voucherData?.value?.map(mapVoucherToVoucherWithDetails) || [];

    // Handle voucher redemption - now opens the drawer
    const handleRedeemVoucher = (id: string) => {
        const voucher = vouchers.find((v) => v.id === id);
        if (voucher) {
            setSelectedVoucher(voucher);
            // Use setTimeout to ensure the drawer is mounted before opening,
            // Reason is to fix the missing initial entrance animation.
            setTimeout(() => {
                setDrawerOpen(true);
            }, 10);
        }
    };

    // Handle drawer close
    const handleCloseDrawer = () => {
        setDrawerOpen(false);
    };

    const Heading = () => {
        return (
            <ProfileHeader
                title={translate('loyalty.vouchers.title')}
                subtitle={translate('loyalty.vouchers.description')}
            />
        );
    };

    return (
        <div className={styles.tabContent}>
            <div className={styles.inner}>
                <Heading />

                <section className={styles.vouchersSection}>
                    <VouchersList
                        vouchers={vouchers}
                        onRedeem={handleRedeemVoucher}
                        isLoading={isLoading}
                        hasError={!!error}
                    />
                </section>

                {selectedVoucher && (
                    <VouchersCardDrawer
                        open={drawerOpen}
                        onClose={handleCloseDrawer}
                        voucher={selectedVoucher}
                    />
                )}
            </div>
        </div>
    );
};

export default Vouchers;
